var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseModal',{attrs:{"config":_vm.docModalConfig}},[_c('BaseDocumentMgrandDropoff',{ref:"investmentDocumentMgr",attrs:{"mgrGridQuery":_vm.filterCondition,"businessEvent":_vm.businessEvent,"transactionRecord":_vm.transactionRecord}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }